// @owners { team: patients }
import { createSelector } from 'reselect';
import { getDeliveries } from './getDeliveries';
import { BILLING_ISSUES } from '~shared/constants';

export const getNeedsInsuranceDeliveries = createSelector([getDeliveries], (deliveries) => {
  return deliveries.filter(({ comms_state }) => comms_state === BILLING_ISSUES.needs_insurance);
});
